import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { StatusBadge, Money } from "@/components/shared/Common";

export default function DoctorAppointments() {
  const [appts, setAppts] = useState([]);
  useEffect(() => { api.get("/appointments/mine").then(r => setAppts(r.data)); }, []);
  return (
    <div className="space-y-6">
      <div><div className="cm-eyebrow mb-2">Appointments</div><h1 className="cm-h2">Your consultations</h1></div>
      <div className="cm-card divide-y divide-[#e2e8f0]" data-testid="dr-appts-list">
        {appts.length === 0 && <div className="text-sm text-[#475569] py-2">No appointments yet.</div>}
        {appts.map(a => (
          <div key={a.id} className="py-4 first:pt-0 last:pb-0 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div>
              <div className="font-semibold text-[#1a2b4a]">{(a.slot_datetime||"").replace("T"," ").slice(0,16)}</div>
              <div className="text-xs text-[#475569] capitalize">{a.consultation_type} · {a.reason || "general"}</div>
            </div>
            <div className="flex items-center gap-3">
              <StatusBadge status={a.status}/>
              <div className="text-sm font-semibold text-[#1a2b4a]"><Money amount={a.doctor_payout} currency={a.currency}/></div>
              <Link to={`/doctor/consultation/${a.id}`} className="cm-btn-primary" data-testid={`dr-open-${a.id}`}>Open</Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
